import { Controller } from "@hotwired/stimulus"

// The ingredient checklist inside the "Add to grocery list" popup — lets the
// user type a new ingredient (in addition to whatever a remembered checklist
// or blank-entry state already rendered server-side) without leaving the sheet.
export default class extends Controller {
  static targets = ["checklist", "newItemInput"]

  addTyped(event) {
    event?.preventDefault?.()

    const value = this.newItemInputTarget.value.trim()
    if (!value) return

    this.checklistTarget.appendChild(this.#buildRow(value))
    this.newItemInputTarget.value = ""
    this.newItemInputTarget.focus()
  }

  // A typo (e.g. "may" meant to be "mayo") had no fix short of leaving the
  // wrong row unchecked forever — remove the whole row so retyping the
  // correct one is the obvious next step.
  remove(event) {
    event.currentTarget.closest("[data-quick-meal-ingredients-target='row']")?.remove()
  }

  #buildRow(value) {
    const row = document.createElement("div")
    row.dataset.quickMealIngredientsTarget = "row"
    row.className =
      "flex items-center gap-2 rounded-xl border border-warm-200 dark:border-gray-600 has-[:checked]:border-warm-500 has-[:checked]:bg-warm-50 dark:has-[:checked]:bg-warm-900/20"

    const label = document.createElement("label")
    label.className = "flex flex-1 min-w-0 items-center gap-3 px-3 py-2.5 cursor-pointer"

    const checkbox = document.createElement("input")
    checkbox.type = "checkbox"
    checkbox.name = "ingredient_names[]"
    checkbox.value = value
    checkbox.checked = true
    checkbox.className = "h-5 w-5 rounded border-gray-300 accent-warm-500 focus:ring-warm-400"

    const span = document.createElement("span")
    span.className = "text-sm font-medium text-gray-800 dark:text-gray-100 truncate"
    span.textContent = value

    label.append(checkbox, span)

    const removeButton = document.createElement("button")
    removeButton.type = "button"
    removeButton.ariaLabel = `Remove ${value}`
    removeButton.dataset.action = "click->quick-meal-ingredients#remove"
    removeButton.className =
      "shrink-0 mr-2 flex h-8 w-8 items-center justify-center rounded-full text-gray-300 hover:text-red-400 dark:text-gray-500 dark:hover:text-red-400"
    removeButton.innerHTML =
      '<svg aria-hidden="true" class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/></svg>'

    row.append(label, removeButton)
    return row
  }
}
